import React from "react";
import logger from "@/lib/logger";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50">
          <div className="max-w-md text-center">
            <div className="text-4xl font-bold text-[#1B3C87] mb-2" style={{ fontFamily: "Chivo" }}>GMS</div>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Something went wrong</h2>
            <p className="text-sm text-gray-500 mb-4">
              The app encountered an error. This may be due to a network issue or a temporary problem.
            </p>
            <button
              onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
              className="px-4 py-2 bg-[#1B3C87] text-white rounded-md text-sm font-semibold hover:bg-[#2650A8] transition-colors"
            >
              Reload App
            </button>
            <p className="text-xs text-gray-400 mt-3">{this.state.error?.message}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
